import { AttributeSelectedColorfulOption } from '@/fo/api/magento';

import { LabelBrand } from '../types';

const mapBrand = (brand: AttributeSelectedColorfulOption): LabelBrand => ({
  name: brand.label,
  url: brand.url ? `/${brand.url}` : '',
  color: brand.color ? `#${brand.color}` : ''
});

export const labelsBrandMapper = (
  brand: AttributeSelectedColorfulOption | null,
  gammas: AttributeSelectedColorfulOption[]
): LabelBrand[] => {
  return [...(brand ? [brand] : []), ...(gammas ?? [])].map(mapBrand);
};
